export const calculateCartItems = (cart) => {

    let all = 0;

    if (cart?.directionTo?.departureTransfer?.id) {
        all++;
    }

    if (cart?.directionTo?.arrivalTransfer?.id) {
        all++;
    }

    if (cart?.directionTo?.departureLounge?.id) {
        all++;
    }

    if (cart?.directionTo?.departureParking?.id) {
        all++;
    }

    if (cart?.directionFrom?.departureTransfer?.id) {
        all++;
    }

    if (cart?.directionFrom?.arrivalTransfer?.id) {
        all++;
    }

    if (cart?.directionFrom?.departureLounge?.id) {
        all++;
    }

    if (cart?.directionFrom?.departureParking?.id) {
        all++;
    }

    if (cart?.directionTo?.departureFastTrack?.id) {
        all++;
    }

    if (cart?.directionFrom?.departureFastTrack?.id) {
        all++;
    }

    return all;

}

export const calculateCartPrice = (cart) => {
    let total = 0;

    total += (cart?.directionFrom?.departureTransfer?.priceInCurrency) ?? 0;
    total += (cart?.directionTo?.departureTransfer?.priceInCurrency) ?? 0;
    total += (cart?.directionFrom?.arrivalTransfer?.priceInCurrency) ?? 0;
    total += (cart?.directionTo?.arrivalTransfer?.priceInCurrency) ?? 0;
    total += (cart?.directionFrom?.departureParking?.priceInCurrency) ?? 0;
    total += (cart?.directionFrom?.departureLounge?.priceInCurrency) ?? 0;
    total += (cart?.directionTo?.departureLounge?.priceInCurrency) ?? 0;
    total += (cart?.directionTo?.departureFastTrack?.priceInCurrency) ?? 0;
    total += (cart?.directionFrom?.departureFastTrack?.priceInCurrency) ?? 0;

    return total;
}

export const isInCart = (cart, p) => {
    let inCartDirection = null;

    if(cart?.directionFrom?.departureTransfer?.offerId&&cart?.directionFrom?.departureTransfer?.offerId===p?.offerId){
        inCartDirection = 'directionFrom-departureTransfer';
    }
    else if(cart?.directionTo?.departureTransfer?.offerId&&cart?.directionTo?.departureTransfer?.offerId===p?.offerId){
        inCartDirection = 'directionTo-departureTransfer';
    }
    else if(cart?.directionFrom?.arrivalTransfer?.offerId&&cart?.directionFrom?.arrivalTransfer?.offerId===p?.offerId){
        inCartDirection = 'directionFrom-arrivalTransfer';
    }
    else if(cart?.directionTo?.arrivalTransfer?.offerId&&cart?.directionTo?.arrivalTransfer?.offerId===p?.offerId){
        inCartDirection = 'directionTo-arrivalTransfer';
    }
    else if(cart?.directionFrom?.departureParking?.offerId&&cart?.directionFrom?.departureParking?.offerId===p?.offerId){
        inCartDirection = 'directionFrom-departureParking';
    }
    else if(cart?.directionFrom?.departureLounge?.offerId&&cart?.directionFrom?.departureLounge?.offerId===p?.offerId){
        inCartDirection = 'directionFrom-departureLounge';
    }
    else if(cart?.directionTo?.departureLounge?.offerId&&cart?.directionTo?.departureLounge?.offerId===p?.offerId){
        inCartDirection = 'directionTo-departureLounge';
    }
    else if(cart?.directionFrom?.departureFastTrack?.offerId&&cart?.directionFrom?.departureFastTrack?.offerId===p?.offerId){
        inCartDirection = 'directionFrom-departureFastTrack';
    }
    else if(cart?.directionTo?.departureFastTrack?.offerId&&cart?.directionTo?.departureFastTrack?.offerId===p?.offerId){
        inCartDirection = 'directionTo-departureFastTrack';
    }

    return {
        isInCart: !!inCartDirection,
        direction: inCartDirection
    };
}